// @flow
import React from "react";
import { withToastManager } from "react-toast-notifications";
// Traduction
import { injectIntl } from "react-intl";
import { TESLASTARS_DG_ID } from "../../../../const";
import DriverGroup from "../../DriverGroup";

class TeslaStars extends React.Component<Props, State> {
	render() {

		return <DriverGroup {...this.props} displayHeaderFooter={true} driver_group={TESLASTARS_DG_ID}/>;
	}
}

export default injectIntl(withToastManager(TeslaStars));
